import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFieldComponent } from './form-field/form-field.component';
import { FormFeildGroupComponent } from './form-feild-group/form-feild-group.component';
import { ScrollableComponent } from './scrollable/scrollable.component';
import { ModalComponent } from './modal/modal.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { CurrencyComponent } from './currency/currency.component';
import { LoadingComponent } from './loading/loading.component';
import { SwitchComponent } from './switch/switch.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule, InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { RouterModule } from '@angular/router';
import { ErrorComponent } from './error/error.component';
import { SuccessComponent } from './success/success.component';
import { VerticalLineComponent } from './vertical-line/vertical-line.component';
import { TextCopyComponent } from './text-copy/text-copy.component';
import { EmptyComponent } from './empty/empty.component';
import { PageNotificationComponent } from './page-notification/page-notification.component';
import { ImageTextComponent } from './image-text/image-text.component';
import { UserAccessComponent } from './user-access/user-access.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { ConvertArabicNumbersDirective } from './directives/convert-arabic-numbers.directive';
import { GaDirective } from './directives/ga.directive';
import { MetaModule } from '../meta/meta.module';
import { JoyrideModule } from 'ngx-joyride';
import { VipModalComponent } from './vip-modal/vip-modal.component';
import { PriceChartComponent } from './price-chart/price-chart.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AutofocusDirective } from './directives/autofocus.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { ShowPasswordDirective } from './directives/show-password.directive';
import { TooltipComponent } from './tooltip/tooltip.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { SpinnerComponent } from './spinner/spinner.component';
import { CountryComponent } from './country/country.component';
import { PromotionsNotificationComponent } from './promotions-notification/promotions-notification.component';
import { AlertModalComponent } from './alert-modal/alert-modal.component';
import { ChartDurationPickerComponent } from './chart-duration-picker/chart-duration-picker.component';
import { PasswordComplexityComponent } from './password-complexity/password-complexity.component';
import { BadgeComponent } from './badge/badge.component';
import { SearchComponent, SearchCryptoComponent, SearchCryptoFeeComponent } from './search/search.component';
import { CarouselComponent } from './carousel/carousel.component';
import { TradingChartComponent } from './trading-chart/trading-chart.component';
import { CaptchaComponent } from './captcha/captcha.component';
import { PaginationComponent } from './pagination/pagination.component';
import {MaxRangeDirective} from './directives/calendar.maxrange.directive';
import { BaseChartComponent } from './base-chart/base-chart.component';

@NgModule({
  entryComponents: [TooltipComponent],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    MetaModule,
    OverlayModule,
    MatSlideToggleModule,
    JoyrideModule.forChild(),
  ],
  providers: [
    InfiniteScrollDirective,
  ],
  declarations: [
    FormFieldComponent,
    FormFeildGroupComponent,
    ScrollableComponent,
    ModalComponent,
    FileUploaderComponent,
    ProgressBarComponent,
    CurrencyComponent,
    LoadingComponent,
    SwitchComponent,
    ErrorComponent,
    SuccessComponent,
    VerticalLineComponent,
    TextCopyComponent,
    EmptyComponent,
    PageNotificationComponent,
    ImageTextComponent,
    UserAccessComponent,
    ConfirmModalComponent,
    ConvertArabicNumbersDirective,
    GaDirective,
    VipModalComponent,
    PriceChartComponent,
    AutofocusDirective,
    MaxRangeDirective,
    TooltipDirective,
    ShowPasswordDirective,
    TooltipComponent,
    SpinnerComponent,
    CountryComponent,
    PromotionsNotificationComponent,
    AlertModalComponent,
    ChartDurationPickerComponent,
    PasswordComplexityComponent,
    BadgeComponent,
    SearchCryptoComponent,
    SearchCryptoFeeComponent,
    SearchComponent,
    CarouselComponent,
    TradingChartComponent,
    CaptchaComponent,
    PaginationComponent,
    BaseChartComponent,
  ],
  exports: [
    FormFieldComponent,
    FormFeildGroupComponent,
    ScrollableComponent,
    ModalComponent,
    FileUploaderComponent,
    ProgressBarComponent,
    SwitchComponent,
    CurrencyComponent,
    LoadingComponent,
    ErrorComponent,
    SuccessComponent,
    VerticalLineComponent,
    TextCopyComponent,
    EmptyComponent,
    PageNotificationComponent,
    ImageTextComponent,
    UserAccessComponent,
    ConfirmModalComponent,
    ConvertArabicNumbersDirective,
    GaDirective,
    MetaModule,
    JoyrideModule,
    VipModalComponent,
    PriceChartComponent,
    ChartDurationPickerComponent,
    AutofocusDirective,
    TooltipDirective,
    ShowPasswordDirective,
    TooltipComponent,
    SpinnerComponent,
    CountryComponent,
    PromotionsNotificationComponent,
    AlertModalComponent,
    PasswordComplexityComponent,
    BadgeComponent,
    SearchCryptoComponent,
    SearchCryptoFeeComponent,
    CarouselComponent,
    TradingChartComponent,
    CaptchaComponent,
    PaginationComponent,
    MaxRangeDirective,
  ]
})
export class GeneralModule { }
